<template>
  <p-button class="btn btn-primary w-75"
            style="max-width: 350px"
            @click="openConfirmSaveAssignmentsModal">
    Save Selected Assignments to Ptrac
  </p-button>
</template>

<script>
export default {
  props: ['assignmentIdsToSave'],

  methods: {
    openConfirmSaveAssignmentsModal() {
      this.$eventHub.$emit('show-modal-1', "Confirm Save Assignments", { assignmentIdsToSave: Array.from(this.assignmentIdsToSave) }, '500px')
    },
  },
}
</script>
